import React from 'react';
export function IntroSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-2432">
      <p className="text-gray-700 text-lg leading-relaxed" data-id="element-2433">
        Throughout the last few decades, hard milling has captured the attention
        of manufacturers around the world. These manufacturers are typically
        focused on the mold and die industry where materials such as P20, H13,
        S7 and others are commonly cut. Traditionally, core and cavities from
        these materials are manufactured in the hardened state using EDM.
        Through the years, new technologies have been developed where these
        materials can be, in most cases, machined directly into hardened
        material using new toolpath processing techniques in combination with
        high-speed machining (HSM) techniques to form hard milling. These
        materials can range from 45 HRc to as hard as 64 HRc.
      </p>
    </div>;
}